import React, { memo } from 'react';
import { Icon } from 'antd';
import { HiOutlinePhotograph } from 'react-icons/hi';
import { MdCrop } from 'react-icons/md';
import {
  useInitialBlockActions,
  useInitialBlockState,
} from '../../features/initialBlock';
import UploadBlock from '../UploadBlock/UploadBlock';
import Skeleton from './components/Skeleton/Skeleton';
import Btn from '../Btn/Btn';
import Cover from './components/Cover/Cover';

const AddFileBtn = () => {
  const { onAddFileClick } = useInitialBlockActions();

  return (
    <Btn
      tooltipTitle="Загрузить изображение"
      onClick={onAddFileClick}
    >
      {({ className }) => (
        <Icon
          component={HiOutlinePhotograph}
          className={className}
        />
      )}
    </Btn>
  );
};

const ChangeCropAreaBtn = () => {
  const { onChangeCropAreaClick } = useInitialBlockActions();

  return (
    <Btn
      tooltipTitle="Изменить область отображения"
      onClick={onChangeCropAreaClick}
    >
      {() => <Icon component={MdCrop} />}
    </Btn>
  );
};

const DeleteBtn = () => {
  const { onDelete } = useInitialBlockActions();

  return (
    <Btn
      tooltipTitle="Удалить"
      onClick={onDelete}
      style={{ color: '#ff7875' }}
    >
      {() => <Icon type="delete" />}
    </Btn>
  );
};

const InitialBlock = () => {
  const { src, inForm, canDelete } = useInitialBlockState();

  if (src) {
    return (
      <Cover src={src}>
        <AddFileBtn />
        <ChangeCropAreaBtn />
        {canDelete && <DeleteBtn />}
      </Cover>
    );
  }

  return inForm ? (
    <UploadBlock />
  ) : (
    <Skeleton>
      <AddFileBtn />
    </Skeleton>
  );
};

export default memo(InitialBlock);
